import { render, staticRenderFns } from "./SetView.vue?vue&type=template&id=080152a5&"
import script from "./SetView.vue?vue&type=script&lang=js&"
export * from "./SetView.vue?vue&type=script&lang=js&"
import style0 from "./SetView.vue?vue&type=style&index=0&id=080152a5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports